import React from "react";
import Icon from "../common/Icon";

const TABS = [
  { key: "purchase", label: "Node Purchase", icon: "node" },
  { key: "scntoken", label: "SCN Token", icon: "coins" },
  { key: "scndex", label: "SCN DEX", icon: "spark" },
  { key: "coredex", label: "CORE DEX", icon: "layers" },
  { key: "coretoken", label: "CORE Token", icon: "fraction" },
  { key: "coremining", label: "CORE Mining", icon: "gauge" },
];

export default function TabNav({ active, onChange }) {
  return (
    <div className="tabnav">
      {TABS.map((t) => (
        <button
          key={t.key}
          className={`tabnav-btn ${active === t.key ? "active" : ""}`}
          onClick={() => onChange(t.key)}
        >
          <Icon name={t.icon} size={15} /> {t.label}
        </button>
      ))}
    </div>
  );
}
